import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { embedDashboard } from '@superset-ui/embedded-sdk';
import axios from 'axios';
import { Container, Row, Col, Button, Card } from 'reactstrap';

import { Storage } from 'react-jhipster';
import { useAppSelector } from 'app/config/store';
import { hasPermissions } from 'app/shared/auth/private-route';
import { PERMISSIONS } from 'app/config/constants';

export default function SupersetIframe() {
  const permissions = useAppSelector(state => state.authentication.account.permissions);
  const showCreateReports = hasPermissions(permissions, [PERMISSIONS.ALL]);
  const dashboardList_dash = 'e13fe234-ef26-462f-bc77-30516d8d7a84';
  const navigate = useNavigate();

  async function getSuperSetToken() {
    const rsToken = Storage.local.get('jhi-authenticationToken') || Storage.session.get('jhi-authenticationToken');

    const rs_header = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + rsToken,
      },
    };

    await axios.get('api/super-set/token?dashboardId=' + dashboardList_dash, rs_header).then(dt => {
      if (dt.data['dashboardId']) {
        embedDashboard({
          id: dt.data['dashboardId'],
          supersetDomain: dt.data['superSetUrl'],
          mountPoint: document.getElementById('superset-container') as HTMLElement,
          fetchGuestToken: () => {
            return dt.data['token'];
          },
          dashboardUiConfig: { hideTitle: true },
        });
      }
    });

    const iframe = document.querySelector('iframe');
    if (iframe) {
      iframe.style.width = '100%';
      iframe.style.minHeight = '60vw';
    }
  }
  useEffect(() => {
    getSuperSetToken();
  }, []);

  const showReports = () => {
    window.location.href = '/reports';
  };

  const redirectToHome = () => {
    navigate('/');
  };
  return (
    <Card className="jh-card">
      <h2 id="device-heading" data-cy="DeviceHeading">
        <div className="d-flex justify-content-between">
          <div className="mt-2 reportsHeading" onClick={showReports}>
            Reports
          </div>
          {showCreateReports && (
            <Link
              to="https://superset.preprodrainspot.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary jh-create-entity ml-5"
              id="linkEntity"
              data-cy="entityCreateButton"
              onClick={redirectToHome}
            >
              Create Reports
            </Link>
          )}
        </div>
      </h2>
      <Container fluid className="py-3">
        <Row className="mb-3">
          <Col>
            <Row>
              <Col>
                <div id="superset-container"></div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </Card>
  );
}
